import { VStack } from "@chakra-ui/react"
import BGMode from "@pathwright/web/src/modules/components/BGMode"
import { useOnRegistrationOrderFulilled } from "../register/components/OrderRegistrationButton"
import RegisterFlow from "../register/components/RegisterFlow"

function OfferRegisterModal(props) {
  const onRegistrationOrderFulfilled = useOnRegistrationOrderFulilled()

  return (
    <VStack
      className="CoverPageRegisterAdapter"
      align="center"
      justify="center"
      maxH="100%"
      minH="220px"
      minW="300px"
      w="100%"
      overflowY="auto"
      sx={{
        [".RegisterFlow"]: {
          bgColor: "transparent"
        },
        [".RegisterFlow .RegisterHeader__close, .RegisterFlow .RegisterFlowHeader"]:
          {
            display: "none"
          }
      }}
    >
      <BGMode
        borderRadius="card"
        bgColor="blackAlpha.300"
        minW="min(500px, 100%)"
        minH="200px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <RegisterFlow
          {...props}
          onOrderFulfilled={onRegistrationOrderFulfilled}
        />
      </BGMode>
    </VStack>
  )
}

export default OfferRegisterModal
